'use memo'

import React from 'react'
import { FullScreenModal } from 'src/components/FullScreenModal'
import { EditPlayerProvider } from './EditPlayerContext'
import EditPlayerModalContent from './EditPlayerModalContent'
import type { ModalTrailItem } from './types/modalTrail'

interface Props {
  isOpen: boolean
  onClose: () => void
  /**
   * When provided, the player is fetched (GET /players/:id via React Query) and
   * the form is pre-populated. When absent, the form opens empty and no fetch
   * happens. Any feature can reuse this modal as an entry point by passing a
   * playerId.
   */
  playerId?: string
  onSuccess?: () => void
  /** Where the screen was opened from, for its breadcrumb ("Profile"). */
  trail?: ModalTrailItem[]
  /**
   * A "Back to …" link in the header, instead of a breadcrumb, for screens
   * opened from a page about this player (Profile, the Player page).
   */
  backLabel?: string
}

const EditPlayerModal: React.FC<Props> = ({
  isOpen,
  onClose,
  playerId,
  onSuccess,
  trail,
  backLabel,
}) => (
  // `page` width: the wide (1600px) full-screen column.
  <FullScreenModal isOpen={isOpen} width='page'>
    <EditPlayerProvider
      onClose={onClose}
      onSuccess={onSuccess}
      playerId={playerId}
    >
      <EditPlayerModalContent trail={trail} backLabel={backLabel} />
    </EditPlayerProvider>
  </FullScreenModal>
)

export default EditPlayerModal
